import {
  addDays,
  isMonday,
  isTuesday,
  isWednesday,
  isThursday,
  isFriday,
  isSaturday,
  isSunday
} from 'date-fns'
const TOKEN = '_UFO'
const TOKEN_EXPIRE = '_EXPIRE'
const USER_ID = '_SKATE'

const currentDate = Date.now()
const cleanUrl = (url) => {
  return encodeURIComponent(url.trim()
    .replace(/\n/g, '')
    .replace(/\s+/g, ''))
}

const getApiDomain = () => {
  if (process.env.NODE_ENV === 'production') {
    if (window.location.hostname.includes('test')) {
      return 'https://api-prod.railroad.ng/v1/'
    }
    return 'https://api-prod.railroad.ng/v1/'
  }
  return 'http://localhost:8000/v1/'
}

const getEnv = () => {
  if (process.env.NODE_ENV === 'production') {
    if (window.location.hostname.includes('test')) {
      return 'staging'
    }
    return 'live'
  }
  return 'local'
}

// TODO cache the result
const getRouteTravelDays = (routeTravelDays = [], time) => {
  // check whether time is monday
  let shouldDisable = false
  if (isSunday(time) && routeTravelDays.includes('SUN')) {
    shouldDisable = true
  }
  if (isMonday(time) && routeTravelDays.includes('MON')) {
    shouldDisable = true
  }

  if (isTuesday(time) && routeTravelDays.includes('TUE')) {
    shouldDisable = true
  }

  if (isWednesday(time) && routeTravelDays.includes('WED')) {
    shouldDisable = true
  }

  if (isThursday(time) && routeTravelDays.includes('THU')) {
    shouldDisable = true
  }
  if (isFriday(time) && routeTravelDays.includes('FRI')) {
    shouldDisable = true
  }
  if (isSaturday(time) && routeTravelDays.includes('SAT')) {
    shouldDisable = true
  }
  return shouldDisable
}

const daysRouteTravelIsActive = (time, routeTravelDays) => {
  const today = currentDate
  const future = addDays(today, 7)
  const routeDisableDays = getRouteTravelDays(routeTravelDays.split(','), time)
  return (time.getTime() <= today) ||
    (time.getTime() > future.getTime()) || routeDisableDays
}

export {
  TOKEN,
  TOKEN_EXPIRE,
  cleanUrl,
  getApiDomain,
  daysRouteTravelIsActive,
  USER_ID,
  getEnv
}



// WEBPACK FOOTER //
// ./src/utils/index.js